import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 16a4 4 0 1 0 8 0a4 4 0 1 0 -8 0","key":"svg-0"}],["path",{"d":"M12 12v-8","key":"svg-1"}],["path",{"d":"M9 7l3 -3l3 3","key":"svg-2"}]]

/**
 * IconSwipeUp
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc3dpcGUtdXAiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTggMTZhNCA0IDAgMSAwIDggMGE0IDQgMCAxIDAgLTggMCIgLz4KICA8cGF0aCBkPSJNMTIgMTJ2LTgiIC8+CiAgPHBhdGggZD0iTTkgN2wzIC0zbDMgMyIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/swipe-up
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconSwipeUp = createReactComponent('outline', 'swipe-up', 'SwipeUp', __iconNode);

export default IconSwipeUp;